import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, forwardRef, inject, input, output, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'star-rating',
    templateUrl: './star-rating.component.html',
    styleUrl: './star-rating.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StarRatingComponent),
            multi: true
        }
    ]
})
export class StarRatingComponent implements ControlValueAccessor {
    private _changeDetectorRef = inject(ChangeDetectorRef);

    starCount = input<number>(5);
    color = input<string>('accent');

    isDisabled: boolean = false;
    onChange: any = () => {};
    onTouched: any = () => { };

    protected ratings = [];
    protected rating = signal(0);

    constructor() {
        effect(() => {
            let i = this.rating();
            this._changeDetectorRef.markForCheck();
        });
    }

    ngOnInit() {
        // TODO: Allow non-numeric rating values.
        for (let index = 0; index < this.starCount(); index++) {
            this.ratings.push(index + 1);
        }
    }

    writeValue(value: any): void {
        this.rating.set(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onInputChange(newValue: any): void {
        this.rating.set(newValue);
        this.onChange(newValue);
        this.onTouched(); // Mark control as touched
    }

    onClick(rating: number) {
        this.onInputChange(rating);
        // this.rating.set(rating);
        return false;
    }

    /**
     * Returns the class for the given start icon index (selected, or not selected) depending on the current rating value.
     * @param index The index of the rating star icon to check.
     * @returns The class name for the star.
     */
    getIcon = (index: number) => (index < this.rating()) ? 'star' : 'star_border';
}
